import React from 'react';
import classNames from 'classnames';

interface SpinnerProps {
    tag?: string;
    className?: string;
    size?: 'lg' | 'md' | 'sm' | 'xs';
    type?: 'bordered' | 'grow';
    color?: string;
    children?: any;
}

/**
 * Spinner
 */
const Spinner = (props: SpinnerProps) => {
    const children = props.children || null;
    const Tag: any = props.tag || 'div';
    const color = props.color || 'secondary';
    const size = props.size || '';
    const type = props.type || 'bordered';

    return (
        <Tag
            role="status"
            className={classNames(
                {
                    'spinner-border': type === 'bordered',
                    'spinner-grow': type === 'grow',
                },
                [`text-${color}`],
                { [`avatar-${size}`]: size },
                props.className
            )}
        >
            {children}
        </Tag>
    );
};

export default Spinner;
